import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { indexQuotasByClientId, showQuota } from "~/modules/client/api/quota/quotaApiDispatchers.ts";

const ENTITY_QUERY_KEY = "quota";

export const QUOTA_QUERY_KEY = (quotaId: string,
	withRelations?: boolean) => [ENTITY_QUERY_KEY, quotaId, withRelations || false];
export const CLIENTS_QUOTAS_QUERY_KEY = (clientId: string) => [ENTITY_QUERY_KEY, clientId];
export const useQuota = (clientId: string, quotaId: string, withRelations?: boolean) => useQuery({
	queryKey: QUOTA_QUERY_KEY(quotaId, withRelations),
	queryFn: () => showQuota(clientId, quotaId, withRelations).then(getDataFromResponse),
	enabled: !!quotaId,
});


export const useClientsQuotas = (clientId: string) => useQuery({
	queryKey: CLIENTS_QUOTAS_QUERY_KEY(clientId),
	queryFn: () => indexQuotasByClientId(clientId).then(getDataFromResponse),
	enabled: !!clientId,
});